module.exports = __webpack_public_path__ + "assets/img/dzh-11.6de7ef8a.jpg";